import { ArrowLeft } from "lucide-react";

import { HeaderNavLinks } from "components/Header/components/HeaderNavLinks/HeaderNavLinks";
import searchStyles from "components/Header/components/HeaderSearch/HeaderSearch.module.css";
import { ProfileDropdown } from "components/Header/components/ProfileDropdown/ProfileDropdown";
import { PatientAutocomplete } from "components/ui/PatientAutocomplete/PatientAutocomplete";

import styles from "./HeaderDesktop.module.css";

export function HeaderDesktop({
  title,
  onBackClick,
  searchProps,
  profileProps,
  navLinksProps,
  practiceName,
}) {
  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <button
          type="button"
          className={styles.navBackBtn}
          onClick={onBackClick}
          aria-label="Go back"
        >
          <ArrowLeft size={24} strokeWidth={2} aria-hidden />
        </button>
        <h1 className={styles.headerTitle}>{title}</h1>
        {/* Which practice this is. Dalen works across several and nothing on screen said
            which (KIN-1141).

            The environment badge that sat beside this was removed (KIN-1862): it named the
            host serving the bundle, not the API being written to, so a local build pointed
            at UAT read "Local" while touching real UAT data. A label that is confidently
            wrong about that is worse than none. */}
        {!!practiceName && (
          <>
            <div className={styles.practiceDivider} />
            <span className={styles.practiceName}>{practiceName}</span>
          </>
        )}
      </div>

      <div className={styles.rightSection}>
        <div className={styles.linksWrap}>
          <div className={styles.navGroup}>
            <div className={searchStyles.searchWrapper}>
              <PatientAutocomplete
                {...searchProps}
                id="header-search-desktop"
              />
            </div>
            <HeaderNavLinks {...navLinksProps} />
          </div>
          <div className={styles.profileDivider} />
          <ProfileDropdown {...profileProps} />
        </div>
      </div>
    </header>
  );
}
